import * as React from 'react'
import { AuthContext } from '../context/AuthContext'

export function useAuthContext() {
  return React.useContext(AuthContext)
}
